import React, { useState, useRef, useContext, useEffect } from "react";
import "../../../assests/css/admin/AdminBlog.css";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import { Spinner } from "react-bootstrap";

const AdminBlog = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTab, setSelectedTab] = useState("dashboard");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const [postToDelete, setPostToDelete] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Form State

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [author, setAuthor] = useState("");
  const [status, setStatus] = useState("published");
  const [tags, setTags] = useState("");
  const [image, setImage] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [formError, setFormError] = useState("");
  const [uploading, setUploading] = useState(false);
  const [blogsIdForUpdate, setBlogsIdForUpdate] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const imageInputRef = useRef(null);

 const addBlogs = async () => {
  const formData = new FormData();

  formData.append("title", title);
  formData.append("description", description);
  formData.append("author", author);
  formData.append("tags", tags);
  formData.append("status", status);

  if (image) {
    formData.append("image", image);
  }

  setUploading(true);

  try {
    const response = await axios.post(
      `${baseUrl}/admin/blogs/addBlogs`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(response.data);

    // Pehle table refresh hoga
    await viewAllBlogs();

    // Table update hone ke baad form reset hoga
    setTitle("");
    setDescription("");
    setAuthor("");
    setTags("");
    setStatus("published");
    setImage("");
    setImagePreview(null);

    setShowForm(false);

  } catch (error) {
    console.log(error);
  } finally {
    // Table refresh hone ke baad spinner band hoga
    setUploading(false);
  }
};

  const updateBlogs = () => {
    console.log("Updated ka function chl rha ha dehan sy dekho");
    const formData = new FormData();
    formData.append("id", blogsIdForUpdate);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("author", author);
    formData.append("tags", tags);
    formData.append("status", status);

    axios
      .post(`${baseUrl}/admin/blogs/updateBlogs`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        viewAllBlogs();
        resetForm();
        setShowModal(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };
const viewAllBlogs = () => {
  return axios
    .get(`${baseUrl}/admin/Blogs/viewAllBlogs`)
    .then((response) => {
      setPosts(response.data.posts);
    })
    .catch((error) => {
      console.log(error);
    });
};

  const handleSubmit = () => {
    if (blogsIdForUpdate === null) {
      addBlogs();
    } else {
      updateBlogs();
    }
  };
  const resetForm = () => {
    setTitle("");
    setDescription("");
    setStatus("Active");
    setAuthor("");
    setTags("");
    setBlogsIdForUpdate(null);
  };

  const handleOpenEditModal = (post) => {
    setBlogsIdForUpdate(post.id);

    setTitle(post.title);

    setDescription(post.description);
    setTags(post.tags);
    setAuthor(post.author);
    setStatus(post.status);
    setShowModal(true);
  };

  const deleteBlogs = (idToDelete) => {
    console.log("*************");
    console.log(idToDelete);
    console.log("*************");
    const formData = new FormData();
    formData.append("id", idToDelete);

    axios
      .post(`${baseUrl}/admin/blogs/deleteBlogs`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllBlogs();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllBlogs();
  }, []);

  const initialPosts = [
  ];

  const [posts, setPosts] = useState([]);

  const filteredPosts = posts.filter((post) => {
    const searchLower = searchQuery.toLowerCase();

    return (
      (post.title || "").toLowerCase().includes(searchLower) ||
      (post.author || "").toLowerCase().includes(searchLower) ||
      (post.tags || "").toLowerCase().includes(searchLower)
    );
  });

  const publishedCount = posts.filter((p) => p.status === "published").length;
  const draftCount = posts.filter((p) => p.status === "draft").length;

  // Image Handler
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // Form Submit
  const handleAddPost = () => {
    if (!title.trim() || !description.trim() || !author.trim()) {
      setFormError("Please fill in Title, Description, and Author.");
      return;
    }
    setFormError("");

    const now = new Date();
    const dateStr = now.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    });

    const newPost = {
      id: Date.now(),
      title: title.trim(),
      description: description.trim(),
      status: status,
      date: dateStr,
      author: author.trim(),
      tags: tags
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean),
      image:
        imagePreview ||
        "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=400&h=300&fit=crop",
    };

    setPosts([newPost, ...posts]);
    // Reset form
    setTitle("");
    setDescription("");
    setAuthor("");
    setStatus("published");
    setTags("");
    setImage(null);
    setImagePreview(null);
    setShowForm(false);
  };

  // const handleDeleteClick = (post) => {
  //   setPostToDelete(post);
  //   setShowDeleteModal(true);
  // };

  // const confirmDelete = () => {
  //   if (postToDelete) {
  //     setPosts(posts.filter(p => p.id !== postToDelete.id));
  //   }
  //   setShowDeleteModal(false);
  //   setPostToDelete(null);
  // };

  // const cancelDelete = () => {
  //   setShowDeleteModal(false);
  //   setPostToDelete(null);
  // };

  const handleTabClick = (tab) => setSelectedTab(tab);

  return (
    <Adminmasterlayout>
      <div className="ab">
        <div className="ab__container">
          {/* ── Header ── */}
          <header className="ab__header">
            <div className="ab__header-left">
              <h1 className="ab__header-title">Blog Management</h1>
              <p className="ab__header-sub">
                Create and manage your blog content
              </p>
            </div>
            <button
              className="ab__btn-new"
              onClick={() => {
                setShowForm((v) => !v);
                setFormError("");
              }}
            >
              <span className="ab__btn-new-icon">{showForm ? "✕" : "+"}</span>
              {showForm ? "Cancel" : "New Post"}
            </button>
          </header>

          {/* ── Stats ── */}
          <div className="ab__stats-grid">
            <div className="ab__stat ab__stat--accent">
              <div className="ab__stat-label">Total Views</div>
              <div className="ab__stat-value">45.2k</div>
              <div className="ab__stat-change">↑ 12% from last month</div>
            </div>
            <div className="ab__stat">
              <div className="ab__stat-label">Total Posts</div>
              <div className="ab__stat-value">{posts.length}</div>
              <div className="ab__stat-meta">{publishedCount} Published</div>
            </div>
            <div className="ab__stat">
              <div className="ab__stat-label">Drafts</div>
              <div className="ab__stat-value">{draftCount}</div>
              <div className="ab__stat-meta ab__stat-meta--warn">
                Pending review
              </div>
            </div>
          </div>

          {/* ── Add Post Form ── */}
          {showForm && (
            <section className="ab__form-section">
              <h2 className="ab__section-title">Add New Post</h2>

              {formError && <div className="ab__form-error">{formError}</div>}

              <div className="ab__form-grid">
                {/* Image Upload */}
                <div className="ab__form-group ab__form-group--image">
                  <label className="ab__form-label">Post Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    ref={imageInputRef}
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <div
                    className="ab__image-uploader"
                    onClick={() => imageInputRef.current.click()}
                  >
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="Preview"
                        className="ab__image-preview"
                      />
                    ) : (
                      <div className="ab__image-placeholder">
                        <span className="ab__image-icon">🖼️</span>
                        <span className="ab__image-hint">Click to upload</span>
                      </div>
                    )}
                  </div>
                  {image && <p className="ab__image-filename">{image.name}</p>}
                </div>

                {/* Text Fields */}
                <div className="ab__form-fields">
                  <div className="ab__form-group">
                    <label className="ab__form-label">
                      Title <span className="ab__required">*</span>
                    </label>
                    <input
                      type="text"
                      className="ab__form-input"
                      placeholder="Enter post title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>

                  <div className="ab__form-group">
                    <label className="ab__form-label">
                      Description <span className="ab__required">*</span>
                    </label>
                    <textarea
                      className="ab__form-input ab__form-textarea"
                      placeholder="Enter post description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      rows={3}
                    />
                  </div>

                  <div className="ab__form-row">
                    <div className="ab__form-group">
                      <label className="ab__form-label">
                        Author <span className="ab__required">*</span>
                      </label>
                      <input
                        type="text"
                        className="ab__form-input"
                        placeholder="Author name"
                        value={author}
                        onChange={(e) => setAuthor(e.target.value)}
                      />
                    </div>
                    <div className="ab__form-group">
                      <label className="ab__form-label">Status</label>
                      <select
                        className="ab__form-input"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="published">Published</option>
                        <option value="draft">Draft</option>
                      </select>
                    </div>
                  </div>

                  <div className="ab__form-group">
                    <label className="ab__form-label">
                      Tags{" "}
                      <span className="ab__form-hint">(comma separated)</span>
                    </label>
                    <input
                      type="text"
                      className="ab__form-input"
                      placeholder="design, ui, trends"
                      value={tags}
                      onChange={(e) => setTags(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="ab__form-footer">
                <button
                  className="ab__btn-cancel"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
                <button
                  className="ab__btn-submit"
                  onClick={handleSubmit}
                  disabled={uploading}
                >
                  {uploading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        style={{ marginRight: "8px" }}
                      />
                      Publishing...
                    </>
                  ) : (
                    "Publish Post"
                  )}
                </button>
              </div>
            </section>
          )}

          {/* ── Search ── */}
          <div className="ab__search-wrap">
            <span className="ab__search-icon">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                <circle
                  cx="8.5"
                  cy="8.5"
                  r="5.5"
                  stroke="#9D9694"
                  strokeWidth="2"
                />
                <path
                  d="M12.5 12.5L16.5 16.5"
                  stroke="#9D9694"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </span>
            <input
              type="text"
              className="ab__search-input"
              placeholder="Search posts, authors, or tags…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                className="ab__search-clear"
                onClick={() => setSearchQuery("")}
              >
                ✕
              </button>
            )}
          </div>

          {/* ── Table ── */}
          <section className="ab__table-section">
            <div className="ab__table-header">
              <h2 className="ab__section-title">
                {searchQuery
                  ? `Results (${filteredPosts.length})`
                  : "All Posts"}
              </h2>
              <span className="ab__table-count">
                {filteredPosts.length} posts
              </span>
            </div>

            <div className="ab__table-wrap">
              {filteredPosts.length === 0 ? (
                <div className="ab__empty">
                  <div className="ab__empty-icon">📭</div>
                  <h3>No posts found</h3>
                  <p>Try a different search or create a new post</p>
                </div>
              ) : (
                <table className="ab__table">
                  <thead className="ab__table-head">
                    <tr>
                      <th className="ab__th ab__th--img">Image</th>
                      <th className="ab__th">Title</th>
                      <th className="ab__th ab__th--hide-sm">Description</th>
                      <th className="ab__th ab__th--hide-md">Author</th>
                      <th className="ab__th ab__th--hide-md">Tags</th>
                      <th className="ab__th">Status</th>
                      <th className="ab__th ab__th--center">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="ab__table-body">
                    {filteredPosts.map((post) => (
                      <tr key={post.id} className="ab__tr">
                        <td className="ab__td ab__td--img">
                          <img
                            // src={post.image}
                            src={`${baseUrlForFiles}/${post.image}`}
                            alt={post.title}
                            className="ab__row-img"
                          />
                        </td>
                        <td className="ab__td ab__td--title">
                          <span className="ab__post-title">{post.title}</span>
                        </td>
                        <td className="ab__td ab__td--desc ab__td--hide-sm">
                          <span className="ab__post-desc">
                            {post.description}
                          </span>
                        </td>
                        <td className="ab__td ab__td--hide-md">
                          <span className="ab__post-author">{post.author}</span>
                        </td>
                        <td className="ab__td ab__td--hide-md">
                          <div className="ab__tags">
                            {post.tags
                              ?.split(",")
                              .slice(0, 2)
                              .map((tag, index) => (
                                <span key={index} className="ab__tag">
                                  {tag.trim()}
                                </span>
                              ))}
                          </div>
                        </td>
                        <td className="ab__td">
                          <span
                            className={`ab__status ab__status--${post.status}`}
                          >
                            {post.status}
                          </span>
                        </td>

                        <td className="ab__td ab__td--actions">
                          <div className="ab__action-group">
                            <button
                              className="ab__action-btn ab__action-btn--edit"
                              title="Edit"
                              onClick={() => handleOpenEditModal(post)}
                            >
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M11.3 2.3L13.7 4.7L5 13.4L2 14L2.6 11L11.3 2.3Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <button
                              className="ab__action-btn ab__action-btn--delete"
                              title="Delete"
                              onClick={() => {
                                deleteBlogs(post.id);
                              }}
                            >
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M3 4H13M5 4V3C5 2.4 5.4 2 6 2H10C10.6 2 11 2.4 11 3V4M6 7V11M10 7V11M4 4L5 13C5 13.6 5.4 14 6 14H10C10.6 14 11 13.6 11 13L12 4"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </section>
        </div>

        {/* ── Bottom Nav ── */}
        <nav className="ab__bottom-nav">
          {[
            {
              key: "dashboard",
              icon: (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="4"
                    y="4"
                    width="6"
                    height="6"
                    fill="currentColor"
                    rx="1"
                  />
                  <rect
                    x="14"
                    y="4"
                    width="6"
                    height="6"
                    fill="currentColor"
                    rx="1"
                  />
                  <rect
                    x="4"
                    y="14"
                    width="6"
                    height="6"
                    fill="currentColor"
                    rx="1"
                  />
                  <rect
                    x="14"
                    y="14"
                    width="6"
                    height="6"
                    fill="currentColor"
                    rx="1"
                  />
                </svg>
              ),
            },
            {
              key: "posts",
              icon: (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="6"
                    y="6"
                    width="12"
                    height="3"
                    fill="currentColor"
                    rx="1"
                  />
                  <rect
                    x="6"
                    y="11"
                    width="12"
                    height="3"
                    fill="currentColor"
                    rx="1"
                  />
                  <rect
                    x="6"
                    y="16"
                    width="12"
                    height="3"
                    fill="currentColor"
                    rx="1"
                  />
                </svg>
              ),
            },
            {
              key: "comments",
              icon: (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7 8H17M7 12H17M7 16H13"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              ),
            },
            {
              key: "settings",
              icon: (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M12 3V5M12 19V21M21 12H19M5 12H3M18.4 5.6L16.9 7.1M7.1 16.9L5.6 18.4M18.4 18.4L16.9 16.9M7.1 7.1L5.6 5.6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              ),
            },
          ].map(({ key, icon }) => (
            <button
              key={key}
              className={`ab__nav-btn ${selectedTab === key ? "ab__nav-btn--active" : ""}`}
              onClick={() => handleTabClick(key)}
            >
              {icon}
              <span>{key.charAt(0).toUpperCase() + key.slice(1)}</span>
            </button>
          ))}
        </nav>

        {/* ── Delete Modal ── */}
        {/* {showDeleteModal && (
          <div className="ab__modal-overlay" onClick={cancelDelete}>
            <div className="ab__modal" onClick={e => e.stopPropagation()}>
              <div className="ab__modal-header">
                <h3>Delete Post</h3>
                <button className="ab__modal-close" onClick={cancelDelete}>✕</button>
              </div>
              <div className="ab__modal-body">
                <div className="ab__modal-icon">⚠️</div>
                <p>Are you sure you want to delete <strong>"{postToDelete?.title}"</strong>?</p>
                <p className="ab__modal-warn">This action cannot be undone.</p>
              </div>
              <div className="ab__modal-footer">
                <button className="ab__modal-btn ab__modal-btn--cancel" onClick={cancelDelete}>Cancel</button>
                <button className="ab__modal-btn ab__modal-btn--delete" onClick={confirmDelete}>Delete</button>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </Adminmasterlayout>
  );
};

export default AdminBlog;
